import { type FnInput, type FnResult, type FunctionsApi } from 'functions';
import axios from 'axios';
import getEnvironmentVariables from './getEnvironmentVariables';
import logger from './logger';

const { TODESKTOP_CLI_FIREBASE_FUNCTIONS_BASE } = getEnvironmentVariables();

function postToFirebaseFunction<K extends keyof FunctionsApi>(
  functionName: K,
  body: FnInput<K>,
  config?: object,
): Promise<FnResult<K>>;
function postToFirebaseFunction(
  functionName: string,
  body?: any,
  config?: object,
): Promise<any>;
async function postToFirebaseFunction(
  functionName: string,
  body: any = {},
  config: object = {},
): Promise<any> {
  logger.debug(
    { scrub: { functionName, body, config } },
    'postToFirebaseFunction',
  );

  let baseUrl = TODESKTOP_CLI_FIREBASE_FUNCTIONS_BASE;
  if (!baseUrl.endsWith('/')) {
    baseUrl += '/';
  }

  try {
    const response = await axios.post(
      `${baseUrl}${functionName}`,
      body,
      config,
    );

    logger.debug(
      { scrub: { responseData: response.data } },
      'postToFirebaseFunction: success',
    );
    return response.data;
  } catch (e) {
    logger.error({ error: e }, 'postToFirebaseFunction: error');
    throw e;
  }
}

export default postToFirebaseFunction;
